import { useEffect, useRef } from 'react';

type EffectCallback = () => void | Promise<void>;

export const useEffectOnce = (callback: EffectCallback, when = true) => {
  const hasRunOnce = useRef(false);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (when && !hasRunOnce.current) {
      hasRunOnce.current = true;
      callbackRef.current();
    }
  }, [when]);
};
